import React from 'react';

export default function ChartOfAccounts() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Chart of Accounts (COA)</h1>
      <p className="text-gray-500">Halaman Chart of Accounts (COA)</p>
    </div>
  );
}
